import React, {useState, useEffect} from 'react';
import {InputGroup, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Spinner} from 'reactstrap';
import {createTwitterFeed, getTwitterPreview} from 'utils/api';
import {textTruncateByWords} from 'utils/other';
import {toast} from 'react-toastify';
import Preview from './components/Preview';
import Header from './components/Header';
import Info from './Info';
import InputField from './components/InputField';
import './Info.scss';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {sortObjects} from 'Helpers/sortObjects';
import SpinnerButton from 'components/SpinnerButton';

const arrayLanguage = [
    'French',
    'Spanish',
    'German',
    'Arabic',
    'Chinese',
    'Danish',
    'Dutch',
    'Greek',
    'Hebrew',
    'Hindi',
    'Italian',
    'Japanese',
    'Korean',
    'Norwegian',
    'Persian',
    'Portuguese',
    'Russian',
    'Swedish',
    'Thai',
    'Ukrainian',
    'Vietnamese',
];

const operatorsArray = [
    'Twitter Account',
    'Keyword',
    'Mentions',
    'Hashtag',
    'Cashtag',
];

const getPlaceholderForOperators = (operator) => {
    switch(operator) {
        case 'Twitter Account':
            return 'Follow a Twitter account';
        case 'Keyword':
            return 'Search twitter';
        case 'Mentions':
            return 'Follow mentions';
        case 'Hashtag':
            return 'Follow Hashtag';
        case 'Cashtag':
            return 'Follow Cashtag';
        default:
            return 'Search Twitter';
    }
};

// const getOperatorForSubmit = (operator) => {
//     switch(operator) {
//         case 'Twitter Account': return '@';
//         case 'Keyword': return '';
//         case 'Mentions': return 'm:';
//         case 'Hashtag': return '#';
//         case 'Cashtag': return '$';
//         default: return '';
//     }
// }

const getOperatorType = (operator) => {
    switch(operator) {
        case 'Twitter Account':
            return 'account';
        case 'Keyword':
            return 'keyword';
        case 'Mentions':
            return 'mention';
        case 'Hashtag':
            return 'hashtag';
        case 'Cashtag':
            return 'cashtag';
        default:
            return '';
    }
};

function TwitterAddField(props) {
    let history = useHistory();

    const [previewLoading, setPreviewLoading] = useState(false);
    const [creationLoading, setCreationLoading] = useState(false);
    const [language, setLanguage] = useState('English');
    const [operator, setOperator] = useState('Twitter Account');
    const [value, handleChange] = useState('');
    const [langDropdown, setLangDropdown] = useState(false);
    const [operDropdown, setOperDropdown] = useState(false);
    const [feed, setFeed] = useState(null);
    const [name, setName] = useState('');
    const [keywordForSubmit, setKeywordForSubmit] = useState('');
    const [publicPageData, setPublicPageData] = useState(null);

    useEffect(() => {
        if(langDropdown) {
            window.addEventListener('keydown', (e) => {
                if(e.key.toLowerCase().match(/[a-z]/i)) {
                    var element = document.querySelector('#' + e.key.toLowerCase());
                    if(element) {
                        element.scrollIntoView({behavior: 'smooth', block: 'center'});
                    }
                }
            });
        }
    }, [langDropdown]);

    const searchChange = (e) => {
        if(e.key === 'Enter') {
            if(e.target.value.trim()) {
                getPreview();
            }
        } else {
            handleChange(e.target.value);
        }
    };

    const getPreview = async() => {
        const data = {
            keyword: value.trimEnd(),
            type: getOperatorType(operator),
            lang: langTransform(language),
        };
        setPreviewLoading(true);
        setFeed(null);
        try {
            let source = await getTwitterPreview(data);
            setKeywordForSubmit(value.trimEnd());
            if(source.length > 100) {
                source = source.slice(0, 100);
            }
            setName(source.content.title);
            let sortedByDate = sortObjects(source.content.news, 'publishedAt', 'desc')
            // setFeed(source.content.news);
            setFeed(sortedByDate);
            setPublicPageData({
                pagePictureUrl: source.content.pictureUrl,
                about: source.content.about,
                title: source.content.title,
            });
            setPreviewLoading(false);
        } catch(e) {
            setPreviewLoading(false);
            if(e.message && e.message.length < 150) {
                toast.error(e.message);
            }
            throw e.message;
        }
    };

    const onSubmit = () => {
        setCreationLoading(true);
        const data = {
            keyword: keywordForSubmit.trimEnd(),
            type: getOperatorType(operator),
            lang: langTransform(language),
            title: name.trim(),
        };
        createTwitterFeed(data)
            .then(() => {
                setCreationLoading(false);
                history.push('/feeds/fetches');
            })
            .catch((err) => {
                setCreationLoading(false);
                if(err.message && err.message.length < 150) {
                    toast.error(err.message);
                }
            });
    };


    const toggleLangDropdown = () => {
        setLangDropdown(!langDropdown);
    };

    const toggleOperatorDropdown = () => {
        setOperDropdown(!operDropdown);
    };

    const handleLanguageChange = (e) => {
        setLanguage(e.target.value);
    };

    const handleOperatorChange = (e) => {
        setOperator(e.target.value);
    };

    const langTransform = (lang) => {
        switch(lang) {
            case 'English':
                return 'en';
            case 'Spanish':
                return 'es';
            case 'German':
                return 'de';
            case 'French':
                return 'fr';
            case 'Arabic':
                return 'ar';
            case 'Chinese':
                return 'zh';
            case 'Danish':
                return 'da';
            case 'Dutch':
                return 'nl';
            case 'Greek':
                return 'el';
            case 'Hebrew':
                return 'iw';
            case 'Hindi':
                return 'hi';
            case 'Italian':
                return 'it';
            case 'Japanese':
                return 'ja';
            case 'Korean':
                return 'ko';
            case 'Norwegian':
                return 'no';
            case 'Persian':
                return 'fa';
            case 'Portuguese':
                return 'pt';
            case 'Russian':
                return 'ru';
            case 'Swedish':
                return 'sv';
            case 'Thai':
                return 'th';
            case 'Ukrainian':
                return 'uk';
            case 'Vietnamese':
                return 'vi';
            default:
                return 'en';
        }
    };

    const cleanPreview = () => {
        handleChange('');
        setFeed(null);
    };


    return (
        props.auth.permissions && !props.auth.permissions.includes('social') ?
            <React.Fragment>
                <Header text="Fetch tweets from Twitter"/>
                <div style={{fontSize: '18px'}}>
                    To follow users, mentions, and keyword searches,<br/> contact Support to access this feature<br/>
                    <a style={{textDecoration: 'underline'}} href="mailto:support@newsfetch.io">
                        support@newsfetch.io
                    </a>
                </div>
            </React.Fragment>
            :
            <div style={{width: '100%'}}>
                <Header text="Fetch tweets from Twitter"/>
                <div style={{display: 'flex'}}>
                    <InputGroup className="d-flex flex-column justify-content-between">
                        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', zIndex: '1'}}>
                            <div style={{position: 'relative', width: '100%'}}>
                                {/* <i className="fab fa-twitter-square source_input-icon" style={{ color: '#1DA1F2' }} /> */}
                                <Input
                                    onKeyPress={(e) => searchChange(e)}
                                    onChange={(e) => searchChange(e)}
                                    value={value}
                                    placeholder={getPlaceholderForOperators(operator)}
                                    type="text"
                                    className="create-fetch_input"
                                    style={{padding: '0 35px 0 10px'}}
                                    autoComplete="off"
                                />
                                {value.trim() && (
                                    <i
                                        style={{bottom: '0'}}
                                        onClick={cleanPreview}
                                        className="fa fa-times-circle create-fetch_inputicon-cross"
                                    />
                                )}
                                {value.trim() && (
                                    <React.Fragment>
                                        {previewLoading ? (
                                            <div className="create-fetch_inputicon-glass"
                                                 style={{display: 'flex', bottom: '0'}}>
                                                {/*<i className="fa fa-spinner fa-spin"/>*/}
                                                <Spinner style={{height: '.95rem', width: '.95rem', borderWidth: '2px', position: 'relative', top: '1px'}} />
                                            </div>
                                        ) : (
                                            <i
                                                style={{bottom: '0'}}
                                                onClick={getPreview}
                                                className="fa fa-search create-fetch_inputicon-glass"
                                            />
                                        )}
                                    </React.Fragment>
                                )}
                            </div>
                            {/*<Button
                            className="calltoaction-button" 
                            style={{ marginLeft: '10px', lineHeight: '0', minWidth: '75px' }} 
                            onClick={() => getPreview()}
                            disabled={!value.trim() || previewLoading}
                        >
                            {previewLoading ? 
                                <div className="flex-centered">
                                    <i className="fa fa-spinner fa-spin" />
                                </div>
                            :
                                <React.Fragment>
                                    <span style={{ fontSize: '14px '}}><i style={{ display: 'inline' }} className="fas fa-plus" /></span>&nbsp;
                                    <span style={{ fontSize: '16px' }}>Add</span>
                                </React.Fragment>
                            }
                        </Button> */}
                        </div>
                        <div style={{display: 'flex'}}>
                            <Info/>
                            <div>
                                <Dropdown isOpen={operDropdown} toggle={(e) => toggleOperatorDropdown(e)}
                                          style={{marginLeft: '10px'}}>
                                    <DropdownToggle
                                        className="twitter_language-dropdown-toggle btn btn-secondary"
                                        caret
                                    >
                                        <div style={{width: '100%'}}>{operator}</div>
                                    </DropdownToggle>
                                    <DropdownMenu className="lang-dropdown-items" id="lang-dropdown">
                                        {operatorsArray.map(oper =>
                                            (operator !== oper) &&
                                            <DropdownItem
                                                style={{height: 'auto'}}
                                                onClick={(e) => handleOperatorChange(e)}
                                                key={oper}
                                                value={oper}
                                                id={oper[0].toLowerCase()}
                                            >
                                                {oper}
                                            </DropdownItem>,
                                        )
                                        }
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                            <div>
                                <Dropdown isOpen={langDropdown} toggle={(e) => toggleLangDropdown(e)}>
                                    <DropdownToggle
                                        className="twitter_language-dropdown-toggle btn btn-secondary"
                                        caret
                                    >
                                        <div style={{width: '100%'}}>{language}</div>
                                    </DropdownToggle>
                                    <DropdownMenu className="lang-dropdown-items" id="lang-dropdown">
                                        <DropdownItem
                                            style={{height: 'auto'}}
                                            onClick={(e) => handleLanguageChange(e)}
                                            value={'English'}
                                            id="e"
                                        >
                                            English
                                        </DropdownItem>
                                        {arrayLanguage.sort().map((lan) =>
                                            (language !== lan) &&
                                            <DropdownItem
                                                style={{height: 'auto'}}
                                                onClick={(e) => handleLanguageChange(e)}
                                                key={lan}
                                                value={lan}
                                                id={lan[0].toLowerCase()}
                                            >
                                                {lan}
                                            </DropdownItem>,
                                        )
                                        }
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </div>
                    </InputGroup>
                </div>
                {feed &&
                <div className="preview-container">
                    <React.Fragment>
                        <div className="twitter-input_container" style={{marginBottom: '10px'}}>
                            <InputField
                                onSubmit={onSubmit}
                                loading={creationLoading}
                                inputPlaceholder="Enter the Newsfeed name"
                                showSubmitGlass={false}
                                parrentDataHandling={true}
                                value={name}
                                handleChange={setName}
                            />
                            <div className="twitter-input_dropdown">
                                {/*<Button*/}
                                {/*    disabled={name.trim() === ''}*/}
                                {/*    style={{color: 'white', minWidth: '125px', margin: '0'}}*/}
                                {/*    onClick={() => onSubmit()}*/}
                                {/*    className="btn typical-button target_input-btn"*/}
                                {/*>*/}
                                {/*    {creationLoading ?*/}
                                {/*        <i className="fa fa-spinner fa-spin"/>*/}
                                {/*        :*/}
                                {/*        'Create Source'*/}
                                {/*    }*/}
                                {/*</Button>*/}
                                <SpinnerButton
                                    minWidth="125px"
                                    title="Create Source"
                                    submitting={creationLoading}
                                    onClick={onSubmit}
                                    disabled={name.trim() === ''}
                                />
                            </div>
                        </div>
                        {publicPageData && publicPageData.pagePictureUrl &&
                        <div className="mt-3 mb-3" style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{height: '50px', marginRight: '10px'}}>
                                <img style={{borderRadius: '50%'}} src={publicPageData.pagePictureUrl}
                                     alt="public page"/>
                            </div>
                            <div>
                                <div style={{fontSize: '1.1rem', fontWeight: '700'}}>{publicPageData.title}</div>
                                {publicPageData.about && <div>{textTruncateByWords(publicPageData.about)}</div>}
                            </div>
                        </div>
                        }
                        <Header text="Preview"/>
                        <Preview feed={feed} sourceType="twitter"/>
                    </React.Fragment>
                </div>
                }
            </div>
    );
}

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateFromProps, null)(TwitterAddField);
